import { validateSize as t } from "./highrise.es289.js";
const e = (r) => t(r) ? r : "sm";
export {
  e as fallbackSize,
  t as validateSize
};
//# sourceMappingURL=highrise.es282.js.map
